package com.klantenstop.web.pages.admin.companies

import com.klantenstop.web.data.models.domain.Company
import com.klantenstop.web.utils.MVI

interface CompaniesContract : MVI<CompaniesContract.State, CompaniesContract.Intent, CompaniesContract.Effect> {

    data class State(
        val companies: List<Company> = emptyList(),
        val isLoading: Boolean = false,
        val searchQuery: String = "",
        val currentPage: Int = 0,
        val totalPages: Int = 0
    )

    sealed class Intent {
        data object LoadCompanies : Intent()
        data class SearchCompanies(val query: String) : Intent()
        data class DeleteCompany(val companyId: String) : Intent()
        data class ChangePage(val page: Int) : Intent()
        data class ApproveCompany(val companyId: String) : Intent()
    }

    sealed class Effect {
        data object NavigateToCreate : Effect()
        data class NavigateToEdit(val companyId: String) : Effect()
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}

